var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5556 23.75H30V16.25H25.5556M33.3333 25C33.3333 25.663 33.0992 26.2989 32.6825 26.7678C32.2657 27.2366 31.7005 27.5 31.1111 27.5H29.4444V31.25H26.1111V27.5H24.4444C23.8551 27.5 23.2898 27.2366 22.8731 26.7678C22.4564 26.2989 22.2222 25.663 22.2222 25V15C22.2222 14.337 22.4564 13.7011 22.8731 13.2322C23.2898 12.7634 23.8551 12.5 24.4444 12.5H31.1111C31.7005 12.5 32.2657 12.7634 32.6825 13.2322C33.0992 13.7011 33.3333 14.337 33.3333 15M17.7778 27.5H14.4444V22.5H10V27.5H6.66667V12.5H10V18.75H14.4444V12.5H17.7778M35.5556 0H4.44444C1.97778 0 0 2.225 0 5V35C0 36.3261 0.468252 37.5979 1.30175 38.5355C2.13524 39.4732 3.2657 40 4.44444 40H35.5556C36.7343 40 37.8648 39.4732 38.6983 38.5355C39.5317 37.5979 40 36.3261 40 35V5C40 3.67392 39.5317 2.40215 38.6983 1.46447C37.8648 0.526784 36.7343 0 35.5556 0Z",
    fill: "#85B6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/Quality.9d3f9040f2078fbb1c0a91bb5573dad5.svg";
export { ForwardRef as ReactComponent };